import { useEffect, useState } from "react";
import { getBugsAndActivities } from "../firebase/utils";

const useFetchBugsAndActivities = () => {
    const [bugsAndActivities, setBugsAndActivities] = useState({
        bugs: [],
        adminActivities: [],
        studentActivities: []
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const data = await getBugsAndActivities();
                setBugsAndActivities(data || {});
            } catch (error) {
                console.error("Error fetching bugs and activities:", error);
                setBugsAndActivities({});
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    return { bugsAndActivities, loading };
};

export default useFetchBugsAndActivities;